import { useState, useRef, useEffect, useContext } from "react";
import "./style.css"
import axios from "axios";
import Context from "../../storage/context";
import useAdminAuth from "../../hooks/useAdminAuth/useAdminAuth";


let _id = 100;
const uid = () => ++_id;

export default function BannerEditor() {
    const [images, setImages] = useState([]);
    const [changed, setChanged] = useState(false);
    const [drag, setDrag] = useState(false);
    const fileRef = useRef(null);
    const [deletionIDs, setDeleteionIDs] = useState([]);
    let [protect, setProtect] = useState(false);

    const CARD_W = 140;
    const CARD_M = 12;
    const loopPx = images.length * (CARD_W + CARD_M);
    const miniItems = [...images, ...images, ...images]; // 3 copies like ReviewsBanner
    const dur = Math.max(images.length * 3, 10);
    let ctx = useContext(Context);

    useAdminAuth(ctx.api_url, setProtect);

    function isObjectURL(value) {
        return typeof value === "string" && value.startsWith("blob:");
    }

    useEffect(() => {

        const fetchCars = async () => {
            try {
                const res = await axios.get(`${ctx.api_url}/banner`);
                setImages(res.data);
            } catch (error) {
                console.error(error);
            }
        };

        if (!changed) {
            fetchCars();
        }
    }, [changed]);

    /* ── upload ── */
    const handleFiles = (files) => {
        const newImgs = Array.from(files)
            .filter(f => f.type.startsWith("image/"))
            .map(f => ({ id: uid(), src: URL.createObjectURL(f), name: f.name.replace(/\.[^.]+$/, ""), isNew: true, file: f }));
        if (!newImgs.length) return;
        setImages(p => [...p, ...newImgs]);
        setChanged(true);
    };

    const onDrop = (e) => { e.preventDefault(); setDrag(false); handleFiles(e.dataTransfer.files); };
    const onDragOver = (e) => { e.preventDefault(); setDrag(true); };
    const onDragLeave = () => setDrag(false);

    /* ── delete ── */
    const del = (id) => { setImages(p => p.filter(i => i.id !== id)); setChanged(true); setDeleteionIDs([...deletionIDs, id]) };

    /* ── save ── */
    const save = async () => {
        let imagesToInsert = images.filter(img => img.isNew);
        let formData = new FormData();

        if (imagesToInsert.length !== 0) {
            imagesToInsert.forEach((item) => {
                formData.append("ids", item.id);
                formData.append("images", item.file);
            });
        }

        await axios.post(`${ctx.api_url}/banner`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${localStorage.getItem("token")}`
            }
        });



        if (deletionIDs.length !== 0) {
            await axios.delete(`${ctx.api_url}/banner`, { data: { ids: deletionIDs } }, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${localStorage.getItem("token")}`

                }
            });
        }


        setImages(p => p.map(i => ({ ...i, isNew: false })));
        setChanged(false);
        setDeleteionIDs([]);


    };

    const newCount = images.filter(i => i.isNew).length;

    return protect && (
        <>
            <div className="be-page">


                <div className="be-wrap">

                    {/* ── live preview ── */}
                    <div className="be-preview-card">
                        <div className="be-preview-head">
                            <div className="be-preview-ico">👁️</div>
                            <span className="be-preview-title">תצוגה מקדימה</span>
                            <span className="be-preview-sub">כך הבאנר נראה באתר</span>
                        </div>
                        <div className="be-mini-banner">
                            <style>{`
                .be-mini-track {
                  --dur: ${dur}s;
                  --loop-px: -${loopPx}px;
                }
              `}</style>
                            <div className="be-mini-track">
                                {miniItems.map((r, i) => (
                                    <div className="be-mini-card" key={i}>
                                        <img src={isObjectURL(r.src) ? r.src : `${ctx.api_url}${r.src}`} alt="" loading="lazy" />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* ── stats ── */}
                    <div className="be-stats">
                        <div className="be-stat">
                            <div className="be-stat__ico">🖼️</div>
                            <div>
                                <div className="be-stat__num">{images.length}</div>
                                <div className="be-stat__lbl">תמונות בבאנר</div>
                            </div>
                        </div>
                        <div className="be-stat">
                            <div className="be-stat__ico">✨</div>
                            <div>
                                <div className="be-stat__num">{newCount}</div>
                                <div className="be-stat__lbl">תמונות חדשות</div>
                            </div>
                        </div>

                    </div>

                    {/* ── upload zone ── */}
                    <div
                        className={`be-upload-zone${drag ? " drag" : ""}`}
                        onClick={() => fileRef.current.click()}
                        onDrop={onDrop}
                        onDragOver={onDragOver}
                        onDragLeave={onDragLeave}
                    >
                        <div className="be-upload-zone__ico">📤</div>
                        <div className="be-upload-zone__txt">גרור תמונות לכאן או לחץ להעלאה</div>
                        <div className="be-upload-zone__sub">PNG, JPG, WEBP — ניתן להעלות מספר תמונות בבת אחת</div>
                        <input ref={fileRef} type="file" accept="image/*" multiple
                            onChange={e => {
                                if (e.target.files.length > 10) {
                                    alert("ניתן לבחור מקסימום 10 קבצים");
                                    e.target.value = "";
                                }
                                handleFiles(e.target.files)
                            }} />
                    </div>

                    {/* ── image grid ── */}
                    <div className="be-section-head">
                        <div className="be-section-label">כל התמונות</div>
                        <div className="be-count">{images.length} תמונות</div>
                    </div>

                    <div className="be-grid">
                        {images.length === 0 && (
                            <div className="be-empty">
                                <div className="be-empty__ico">🖼️</div>
                                אין תמונות — העלה תמונות ראשונות לבאנר
                            </div>
                        )}
                        {images.map(img => (
                            <div className="be-img-card" key={img.id}>
                                <img src={isObjectURL(img.src) ? img.src : `${ctx.api_url}${img.src}`} alt={img.name} loading="lazy" />
                                {img.isNew && <div className="be-img-card__new">חדש</div>}
                                <div className="be-img-card__overlay">
                                    <div className="be-img-card__name">{img.name}</div>
                                    <button className="be-btn-del" onClick={() => del(img.id)}>🗑 הסר</button>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>

                {/* ── save bar ── */}
                {changed && (
                    <div className="be-save-bar">
                        <div className="be-save-bar__info">
                            יש <span>{newCount > 0 ? `${newCount} תמונות חדשות` : "שינויים"}</span> שלא נשמרו
                        </div>
                        <div style={{ display: "flex", gap: 8 }}>
                            <button className="be-btn-cancel" onClick={() => { setDeleteionIDs([]); setChanged(false); }}>
                                בטל שינויים
                            </button>
                            <button className="be-btn-save" onClick={save}>
                                💾 שמור שינויים
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}
